export enum GameModule {
    Lottery = 'lottery',
    Casino = 'casino',
    Sportsbook = 'sportsbook',
    Lootbox = 'lootbox',
}
